<template>
  <div class="w-full">
    <div class="vx-row justify-center">
      <div class="vx-col w-full md:w-1/2">
        <vs-card>
          <div slot="header">
            <div class="vx-row flex justify-between items-center m-2">
              <div class="flex-initial pr-3">
                <img :src="queueDetail.logo | agencyLogo" width="64px"/>
              </div>
              <div class="flex-1">
                <h3 class>{{queueDetail.service_name}}</h3>
                <h6>{{queueDetail.agency_name}}</h6>
              </div>
            </div>
          </div>
          <div class="flex flex-col md:flex-row md:items-stretch">
            <div class="w-full md:w-2/3">
              <div class="vx-col w-full py-2 flex text-lg">
                <div class="flex-initial pr-3">
                  <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-activity" />
                </div>
                <div class="flex-1">{{queueDetail.registration_code}}</div>
              </div>
              <div class="vx-col w-full py-2 flex text-lg">
                <div class="flex-initial pr-3">
                  <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-calendar" />
                </div>
                <div class="flex-1">{{queueDetail.date_book}}</div>
              </div>
              <div class="vx-col w-1/2 py-2 flex text-lg">
                <div class="flex-initial pr-3">
                  <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-clock" />
                </div>
                <div class="flex-1">{{queueDetail.start_time}} - {{queueDetail.end_time}}</div>
              </div>
              <div class="vx-col w-full py-2 flex text-lg">
                <div class="flex-initial pr-3">
                  <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-user" />
                </div>
                <div class="flex-1">{{queueDetail.is_priority == 1 ? 'Mandiri' : 'Kuasa'}}</div>
              </div>
              <div class="vx-col w-full py-2 flex text-lg">
                <div class="flex-initial pr-3">
                  <vs-icon icon-pack="feather" size="small" color="primary" icon="icon-info" />
                </div>
                <div class="flex-1"> <vs-chip :class=" queueDetail.status_label+' text-white'">{{queueDetail.status_view}}</vs-chip></div>
              </div>
            </div>
          </div>
        </vs-card>
      </div>
      <div class="vx-col w-full md:w-1/2">
        <vs-card>
          <div slot="header">
            <div class="vx-row flex justify-between items-center m-2">
              <h3>Timeline</h3>
            </div>
          </div>
          <div class="flex flex-col md:flex-row md:items-stretch">
              <vx-timeline :data="timelineData" />
          </div>
        </vs-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col">
        <vs-button
          color="primary"
          class="mb-5"
          icon-pack="feather"
          icon="icon-arrow-left "
          type="border"
          @click="$router.push('/petugas/antrian/')"
        >Kembali</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import VueQr from 'vue-qr';
import VxTimeline from '@/components/timeline/VxTimeline'
export default {
  data() {
    return {
      queueDetail : [],
      popupActive : false,
      color : ['primary','warning','success'],
      queueList : [],
      timelineData: [
        {
          color: 'success',
          icon: 'ClipboardIcon',
          title: 'Ambil Antrian',
          desc: 'Anda mengambil antrian Loket Perizinan untuk hari senin, 20 Juni 2020 dengan estimasi 09:00 - 10:00',
          time: '18 Juni 2020 08:00'
        },
        {
          color: 'success',
          icon: 'CheckSquareIcon',
          title: 'Registrasi',
          desc: 'Anda melakukan registrasi kedatangan dan mendapatkan nomor antrian A-032',
          time: '20 Juni 2020 08:30'
        },
        {
          color: 'success',
          icon: 'PhoneCallIcon',
          title: 'Dipanggil',
          desc: 'Antrian anda dipanggil oleh Rosita Febrianti ',
          time: '20 Juni 2020 09:30'
        },
        {
          color: 'primary',
          icon: 'HeartIcon',
          title: 'Dilayani',
          desc: 'Anda mendapatkan pelayanan ',
          time: '20 Juni 2020 09:31'
        },
        {
          color: 'grey',
          icon: 'CheckIcon',
          title: 'Selesai Dilayani',
          desc: 'Anda selesai dilayani',
          time: '20 Juni 2020 10:00'
        },
        {
          color: 'grey',
          icon: 'TrashIcon',
          title: 'Memberikan Rating',
          desc: 'Anda memberikan rating PUAS pada layanan Loket Perizinan dengan petugas Rosita Febrianti (Privasi anda terjamin)',
          time: '20 Juni 2020 10:30'
        }
      ],
    };
  },
  components: {
    Datepicker,
    VueQr,
    VxTimeline
  },
  mounted() {
    this.getDetailQueue();
  },
  methods: {
    getDetailQueue(){
      var self = this;
      self.$vs.loading();
      self.$http
      .post(`/app/secure/queue/getDetailQueue`,{registration_code : self.$route.params.registration_code})
      .then(r => { 
        self.queueDetail = r.data.data.queue;
        self.timelineData = r.data.data.timeline;
        if(self.queueDetail.length == 0){
          self.$vs.notify({
            title: `Maaf, history antrian dengan kode registrasi tidak ditemukan !`,
            color: "danger",
          });
          self.$router.push({name : 'antrian'});
        }
        self.$vs.loading.close();
      })
      .catch(e => {
        self.parseError(e);
        self.$vs.loading.close();
      })
    },
    formatterDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
  watch: {
    date() {
      this.init();
    }
  },
  computed: {
    user() {
      return this.$store.state.AppActiveUser;
    }
  }
};
</script>